<template>
  <div class="main-wrap">
    <div id="main-content">
      <div class="wrapper">
        <jm-crumbs/>
        <div class="table-agile-info">
          <el-row class="searchForm" :gutter="10">
            <el-col :span="8" v-if="typeof constDict.roleids === 'object'">
              角色搜索：
              <el-select v-model="searchData.roleid">
                <el-option
                  v-for="item in constDict.roleids"
                  :key="item.roleid"
                  :label="item.name"
                  :value="item.roleid"/>
              </el-select>
            </el-col>
            <el-col :span="8" v-if="typeof constDict.group_list === 'object' && constDict.group_list.length">
              小组：
              <el-select
                v-model="searchData.gid"
                filterable
                clearable>
                <el-option
                  v-for="(option, index) in constDict.group_list"
                  v-if="searchData.roleid === option.group_role_id"
                  :key="index"
                  :label="`${option.group_name}(${option.truename})`"
                  :value="option.gid"/>
              </el-select>
            </el-col>
            <el-col :span="8" v-if="searchData.roleid === 125 && typeof constDict.countries === 'object'">
              国家：
              <el-select
                v-model="searchData.country_id"
                filterable
                clearable>
                <el-option
                  v-for="option in constDict.countries"
                  :key="option.id"
                  :label="option.title"
                  :value="option.id"/>
              </el-select>
            </el-col>
          </el-row>
          <el-row class="searchForm" :gutter="10">
            <el-col :span="8">
              文案老师：
              <el-select
                v-model="searchData.teacher_id"
                title="请选择"
                multiple
                filterable
                clearable>
                <el-option
                  v-for="option in constDict.teacher"
                  v-if="filterTeacher(option)"
                  :key="option.key"
                  :label="option.name"
                  :value="option.key"/>
              </el-select>
            </el-col>
            <el-col :span="8">
              入学时间：
              <el-select
                class="jm-input90"
                v-model="searchData.year">
                <el-option
                  v-for="(option, index) in constDict.year"
                  :key="index"
                  :label="option"
                  :value="index"/>
              </el-select>
              <el-select
                class="jm-input90"
                multiple
                clearable
                v-model="searchData.month">
                <el-option
                  v-for="(option, index) in constDict.month"
                  :key="index"
                  :label="option"
                  :value="index"/>
              </el-select>
            </el-col>
            <el-col :span="8">
              转化时间：
              <el-date-picker
                v-model="searchData.timeline"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd">
              </el-date-picker>
            </el-col>
          </el-row>
          <!-- <el-row
              class="rows"
              :gutter="10">
              <el-col :span="24">
                <div class="rows-div">
                  <p>
                    <span class="s_title">文案办理</span>
                    <span
                      class="s_right"
                      v-if="chartsSort.options.length">排序方式：
                      <el-select
                        v-model="chartsSort.value"
                        placeholder="请选择排序方式"
                        size="mini"
                        class="jm-input135"
                        @change="setChartsSort">
                        <el-option
                          v-for="item in chartsSort.options"
                          :key="item"
                          :label="item"
                          :value="item"/>
                      </el-select>
                    </span>
                  </p>
                  <div class="chart-div">
                    <bi-bar-line
                      :data="chartsData.data"
                      :data1="chartsData.data1"
                      :options="chartsData.options"
                      :refresh="chartsData.refresh"
                      @reload="initCharts"/>
                  </div>
                </div>
              </el-col>
            </el-row> -->

          <jm-tableList
            v-if="searchData"
            url="/index/b_i_teacher2020/getWriterPage"
            :refresh="refresh"
            :search-data="searchData"
            :no-pagination="true"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BiBarLine from '@/components/charts/biBarLine';
import { getAdvisoryTeachers } from '@/api/teacher';
import jmTableList from '@/components/data/tableList';
import common from '@/pages/bi/common';
import { jmChannel } from '@/components/tool';

let constDict = {
  year: ['全部'],
  month: ['全部', '1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
};

export default {
  mixins: [common],
  data() {
    return {
      constDict,
      chartsData: {
        refresh: 1
      },
      chartsSort: {
        options: [],
        value: '资源数'
      },
      refresh: false,
      searchData: {
        gid: '',
        year: 0,
        month: [],
        teacher_id: [],
        timeline: [],
        country_id: 0,
        roleid: ''
      }
    };
  },
  components: {
    BiBarLine, getAdvisoryTeachers, jmChannel, jmTableList
  },
  created() {
    this.$http
      ._get({
        url: '/index/b_i_teacher2020/writerDic'
      })
      .then(({ data }) => {
        this.constDict = Object.assign({}, this.constDict, data);
        console.log('constDict', this.constDict);
        this.searchData.roleid = typeof this.constDict.roleids === 'object' ? this.constDict.roleids[0].roleid : this.constDict.roleids;
        this.searchData.country_id = typeof this.constDict.countries === 'object' ? this.constDict.countries[0].id : 30;
        this.$store.commit('updateRefresh', true);
      });
  },
  methods: {
    init() {
      this.$store.commit('updateRefresh', true);
      // this.initCharts();
    },
    initCharts() {
      this.fetchData({
        url: '/index/b_i_teacher2020/getWriterTeacherChart',
        field: 'chartsData',
        param: this.searchData,
        option: {
          margin: {
            top: 50, right: 30, bottom: 20, left: 0
          },
          colors: ['#409EFF', '#BD48FF', '#FF9F00', '#FF6153'],
          barWidth: 20,
          labelWidthPercent: 100 / 8,
          domainType: 'string',
          groupType: true,
          exY1: '%'
        },
        sort: 'chartsSort'
      });
    },
    setChartsSort() {
      this.chartsData = this.sortData(this.chartsData, this.chartsSort.value);
    },
    filterTeacher(option) {
      let group = (this.searchData.gid && this.searchData.gid === option.group_id) || !this.searchData.gid;
      // let roleid = (this.searchData.roleid && this.searchData.roleid === option.role_id) || !this.searchData.roleid;
      return group;
    }
  },
  watch: {
    searchData: {
      handler: function () {
        this.$nextTick(this.init);
      },
      deep: true
    }
  }
};

</script>

<style scoped>
.searchForm *{
  padding: 5px;
}
</style>
